import Goods from "@material-symbols/svg-500/rounded/category.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const GoodsIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Goods });
	return <Icon />;
};

export default memo(GoodsIcon);
